import { navBarRoute } from "../dataTypes/ReactRouter";
// routes for the navbar, that get passed into a NavLink component
// routes render based on userType
export const ALL_ADMIN = [
  "sadmin",
  "admin",
  "sales",
  "tac",
  "csss",
  "pops",
  "learn",
  "finance",
  "marketing",
  "general",
];
export const navbarRoutes: navBarRoute[] = [
  // {
  //   // admin routes
  //   id: "adminDashboard",
  //   link: "/dashboard/home",
  //   name: "Dashboard",
  //   viewer: ALL_ADMIN,
  // },
  {
    // admin routes
    id: "adminDashboard",
    link: "/dashboardinsight/employers&plan",
    name: "Dashboard",
    viewer: ALL_ADMIN,
  },
  // {
  //   id: "adminEmployers",
  //   link: "/employers",
  //   name: "Employers",
  //   viewer: ALL_ADMIN,
  // },
  // {
  //   id: "adminOpenings",
  //   link: "/jobs",
  //   name: "Jobs",
  //   viewer: ALL_ADMIN,
  // },
  {
    id: "seekerManagement",
    link: "/seekers",
    name: "Seekers",
    viewer: ALL_ADMIN,
  },
  // {
  //   id: "adminAcademy",
  //   link: "/academy",
  //   name: "Academy",
  //   viewer: ALL_ADMIN,
  // },
  // {
  //   id: "adminL&D",
  //   link: "/learning/dashboard",
  //   name: "L&D",
  //   viewer: ["admin", "sadmin", "learn"],
  // },
  {
    id: "adminUserManagement",
    link: "/users",
    name: "Users",
    viewer: ["sadmin", "admin"],
  },
  {
    id: "AdminCohort",
    link: "/cohort",
    name: "Cohort",
    viewer: ["sadmin", "admin"],
  },
  // {
  //   id: "AdminCohort",
  //   link: "/cohort/listing",
  //   name: "Cohort",
  //   viewer: ["sadmin", "admin"],
  // },
  // employer routes
  {
    id: "jobsNew",
    link: "/jobs-new",
    name: "Jobs",
    viewer: ALL_ADMIN,
  },
  {
    id: "adminEmployers-new",
    link: "/employers-new/",
    name: "Employers",
    viewer: ALL_ADMIN,
  },
  {
    id: "employerDashboard",
    link: "/dashboard/home",
    name: "Dashboard",
    viewer: ["GEN", "BILL", "PRI"],
  },

  {
    id: "evetManagement",
    link: "/event-management",
    name: "Events",
    viewer: ALL_ADMIN,
  },
  {
    id: "adminCommunity",
    link: "/admin-community",
    name: "Community",
    viewer: ALL_ADMIN,
  },
  {
    id: "company",
    link: "/company/overview",
    name: "Company",
    viewer: ["GEN", "PRI"],
  },
  {
    id: "employerJobs",
    link: "/jobs",
    name: "Jobs",
    viewer: ["GEN", "BILL", "PRI"],
  },
  {
    id: "ExternalUserManagemet",
    link: "/users",
    name: "Users",
    viewer: ["PRI"],
  },
  {
    id: "companyNotes",
    link: "/notes",
    name: "Notes",
    viewer: ["PRI", "GEN", "BILL"],
  },
  // seeker routes

  {
    id: "seekerJobs",
    link: "/jobs",
    name: "Jobs",
    viewer: ["SKR", "RTM", "COMM"],
  },
  {
    id: "seekerCompanies",
    link: "/companies",
    name: "Companies",
    viewer: ["SKR", "RTM", "COMM"],
  },
  {
    id: "seekerApplications",
    link: "/applications",
    name: "Applications",
    viewer: ["SKR", "RTM", "COMM"],
  },
  {
    id: "seekerOffers",
    link: "/offers",
    name: "Offers",
    viewer: ["SKR", "RTM", "COMM"],
  },
  {
    id: "seekerAcademy",
    link: "/academy",
    name: "Academy",
    viewer: ["SKR", "RTM", "COMM"],
  },
];


export const archivesAdminNavbarRoutes: any = [
  {
    id: "adminEmployers",
    link: "/employers",
    name: "Employers (Old)",
    viewer: ALL_ADMIN,
  },
  {
    id: "adminOpenings",
    link: "/jobs",
    name: "Jobs (Old)",
    viewer: ALL_ADMIN,
  },
  {
    id: "adminAcademy",
    link: "/academy",
    name: "Academy",
    viewer: ALL_ADMIN,
  },
  {
    id: "adminL&D",
    link: "/learning/dashboard",
    name: "L&D",
    viewer: ALL_ADMIN,
  },
  {
    id: "Community Dashboard-insighthub",
    name: "Community App Panel",
    link: "/twelvemillion",
    viewer: ALL_ADMIN,
  },

  //   {
  //   id: "AdminCohort",
  //   link: "/cohort/listing",
  //   name: "Cohort",
  //   viewer: ["sadmin", "admin"],
  // },
]

